export default "__VITE_ASSET__cBrHpfop__"